import {
  LOAD_NOTES_LIST_ACTION, SET_EDITED_NOTE_ACTION, SAVE_EDITED_NOTE_ACTION,
} from '../actions/notes-actions';
import { thriftPlugin } from '../thriftPlugin';

export default {
  state: {
    notesList: [],
    editedNote: undefined,
  },
  actions: {
    [LOAD_NOTES_LIST_ACTION](ctx, categoryId) {
      ctx.commit('setNotesList', []);
      thriftPlugin.NotesService.loadNotes(categoryId)
        .then(
          (response) => {
            ctx.commit('setNotesList', response);
          },
        );
    },
    [SAVE_EDITED_NOTE_ACTION](ctx) {
      const toSave = {
        categoryId: ctx.state.editedNote.categoryId.toString(),
        noteText: ctx.state.editedNote.noteText,
      };
      thriftPlugin.NotesService.saveNote(toSave)
        .then(() => {
          ctx.commit('setEditedNote', undefined);
          ctx.dispatch(LOAD_NOTES_LIST_ACTION);
        });
    },
    [SET_EDITED_NOTE_ACTION](ctx, payload) {
      ctx.commit('setEditedNote', payload);
    },
  },
  mutations: {
    setNotesList(state, list) {
      state.notesList = list;
    },
    setEditedNote(state, note) {
      state.editedNote = note;
    },
  },
  getters: {
    notesList(state) {
      return state.notesList;
    },
    currentNote(state) {
      return state.editedNote;
    },
  },
};
